/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- needed */
import React from 'react';
import PropTypes from 'prop-types';

const DetailLayout = ({ children }) => {
  if (!children) {
    throw new Error('This layout expects children');
  }
  return (
    <div className="col-xs-12 col-md-8 margin-auto-lr margin-3-tb pad-0" data-testid="detail-tile">
      <div>
        {children[0]}
      </div>
    </div>
  );
};

DetailLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default DetailLayout;
